export interface BackgroundPattern {
  id: string;
  name: string;
  style: React.CSSProperties;
}

export const BACKGROUND_PATTERNS: Record<string, BackgroundPattern> = {
  dots: {
    id: 'dots',
    name: 'Polka Dots',
    style: {
      backgroundImage: 'radial-gradient(#e5e7eb 1px, transparent 1px)',
      backgroundSize: '20px 20px',
    },
  },
  grid: {
    id: 'grid',
    name: 'Grid',
    style: {
      backgroundImage: 'linear-gradient(#e5e7eb 1px, transparent 1px), linear-gradient(90deg, #e5e7eb 1px, transparent 1px)',
      backgroundSize: '20px 20px',
    },
  },
  diagonal: {
    id: 'diagonal',
    name: 'Diagonal Stripes',
    style: {
      backgroundImage: 'repeating-linear-gradient(45deg, #f3f4f6, #f3f4f6 10px, #ffffff 10px, #ffffff 20px)',
    },
  },
  checkerboard: {
    id: 'checkerboard',
    name: 'Checkerboard',
    style: {
      backgroundImage: `linear-gradient(45deg, #f3f4f6 25%, transparent 25%), 
        linear-gradient(-45deg, #f3f4f6 25%, transparent 25%), 
        linear-gradient(45deg, transparent 75%, #f3f4f6 75%), 
        linear-gradient(-45deg, transparent 75%, #f3f4f6 75%)`,
      backgroundSize: '20px 20px',
      backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
    },
  },
  paper: {
    id: 'paper',
    name: 'Graph Paper',
    style: {
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.05) 1px, transparent 1px),
        linear-gradient(90deg, rgba(0, 0, 0, 0.05) 1px, transparent 1px)`,
      backgroundSize: '20px 20px',
    },
  },
};
